module.exports = __webpack_public_path__ + "static/media/mobile_untb.d849968f.png";